import styled from 'styled-components';

import { respondDown, textEllipsis } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const Container = styled.div<{
    $isEmbedded?: boolean;
    $disabled: boolean;
    $hasPickerOptions?: boolean;
}>`
    display: flex;
    position: relative;
    min-height: ${({ $hasPickerOptions }) => ($hasPickerOptions ? '16.2rem' : 'auto')};
    padding: ${({ $hasPickerOptions, $isEmbedded }) =>
        $hasPickerOptions ? '3.2rem 4rem' : $isEmbedded ? '2.4rem 3.2rem' : '3.2rem 4rem'};
    background-color: ${COLORS.insetBackground};
    border-radius: 4rem;
    justify-content: space-between;
    align-items: ${({ $hasPickerOptions }) => ($hasPickerOptions ? 'center' : 'stretch')};
    box-sizing: border-box;
    pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
    opacity: ${({ $disabled }) => ($disabled ? '0.7' : '1')};
    ${respondDown(Breakpoints.sm)`
        padding: 3.2rem 1.6rem;
    `}

    ${({ $hasPickerOptions }) =>
        $hasPickerOptions &&
        respondDown(Breakpoints.sm)`
            display: grid;
            grid-template-columns: minmax(0, 1fr) auto;
            grid-template-areas:
                'label percent'
                'amount picker'
                'details details'
                'balance balance';
            gap: 0.8rem 1.2rem;
            min-height: auto;
        `}
`;

export const AmountLabel = styled.span`
    font-size: 1.6rem;
`;

export const AmountDetails = styled.div`
    color: ${COLORS.textGray};
    font-size: 1.4rem;
    line-height: 1.6rem;
    white-space: nowrap;

    ${respondDown(Breakpoints.sm)`
        white-space: normal;
    `}
`;

export const AmountContainer = styled.div<{ $hasPickerOptions?: boolean }>`
    display: flex;
    flex-direction: column;
    width: 50%;
    min-width: 0;
    gap: ${({ $hasPickerOptions }) => ($hasPickerOptions ? '0.8rem' : '0')};

    ${AmountLabel} {
        line-height: ${({ $hasPickerOptions }) => ($hasPickerOptions ? '1.8rem' : 'normal')};
    }

    input {
        ${({ $hasPickerOptions }) =>
            $hasPickerOptions &&
            `
                height: 4.8rem;
                line-height: 4.8rem;
            `}
    }

    ${({ $hasPickerOptions }) =>
        $hasPickerOptions &&
        respondDown(Breakpoints.sm)`
            display: contents;

            ${AmountLabel} {
                grid-area: label;
            }

            > div:first-of-type {
                grid-area: amount;
                min-width: 0;
            }

            ${AmountDetails} {
                grid-area: details;
                min-width: 0;
            }
        `}
`;

export const PickerContainer = styled.div<{ $hasPickerOptions?: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: ${({ $hasPickerOptions }) => ($hasPickerOptions ? '19.1rem' : '50%')};
    gap: ${({ $hasPickerOptions }) => ($hasPickerOptions ? '0.8rem' : '0')};
    align-items: flex-end;

    ${({ $hasPickerOptions }) =>
        $hasPickerOptions &&
        respondDown(Breakpoints.sm)`
            display: contents;

            > div:first-child {
                grid-area: percent;
                justify-self: end;
            }

            > div:nth-child(2) {
                grid-area: picker;
                justify-self: end;
            }

            > div:nth-child(3) {
                grid-area: balance;
                justify-self: end;
            }
        `}
`;

export const Balance = styled.div<{ $hasPickerOptions?: boolean }>`
    font-size: 1.4rem;
    line-height: 1.6rem;
    color: ${COLORS.textGray};
    display: inline-flex;
    align-items: center;
    gap: ${({ $hasPickerOptions }) => ($hasPickerOptions ? '0.8rem' : '0')};
    white-space: nowrap;
    width: ${({ $hasPickerOptions }) => ($hasPickerOptions ? 'auto' : '100%')};

    svg {
        margin-left: ${({ $hasPickerOptions }) => ($hasPickerOptions ? '0' : '0.4rem')};
    }
`;

export const BalanceLabel = styled.span`
    text-align: right;
    ${respondDown(Breakpoints.sm)`
        display: none;
    `}
`;

export const BalanceValue = styled.span<{ $hasPickerOptions?: boolean }>`
    width: ${({ $hasPickerOptions }) => ($hasPickerOptions ? 'auto' : '100%')};
    ${textEllipsis};
    text-align: right;
`;

export const PercentSpacer = styled.div`
    height: 1.8rem;
`;
